<template>
    <div class="activity-map__results">
        <GmapMap
            ref="map"
            :center="center"
            :zoom="8"
            :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: false,
                disableDefaultUi: false,
                scrollwheel: true,
                styles: mapStyle,
                maxZoom: 30
            }"
            style="width: 100%; height: 100vh"
            ><gmap-info-window
                ref="infoWindow"
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen = false"
            >
                <activities-map-slider
                    v-if="render"
                    ref="activitiesMapSlider"
                    :activities="currentActivities"
                ></activities-map-slider>
            </gmap-info-window>
            <GmapMarker
                v-for="(marker, index) in activities"
                :key="index"
                ref="marker"
                :clickable="true"
                :name="marker.providerName"
                :label="{
                    text: marker.amountOfActivitiesOnThisLocation,
                    color: 'white',
                    fontWeight: 'bold'
                }"
                :position="{
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.long)
                }"
                :center="{
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.long)
                }"
                :icon="{
                    url: '/Content/img/pin-purple.png',
                    color: 'yellow',
                    labelOrigin: { x: 19, y: 22 }
                }"
                @click="toggleInfoWindow(marker, index)"
            >
            </GmapMarker>
        </GmapMap>
    </div>
</template>

<script>
const mapStyle = [
    {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
            {
                saturation: 36
            },
            {
                color: '#333333'
            },
            {
                lightness: 40
            }
        ]
    },
    {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                visibility: 'on'
            },
            {
                color: '#ffffff'
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#fefefe'
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#fefefe'
            },
            {
                lightness: 17
            },
            {
                weight: 1.2
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e9e9e9'
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'geometry.stroke',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                color: '#f5f5f5'
            },
            {
                lightness: 21
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                color: '#bfe29b'
            },
            {
                lightness: 21
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 17
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 29
            },
            {
                weight: 0.2
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 18
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
            {
                color: '#f2f2f2'
            },
            {
                lightness: 19
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
            {
                color: '#c6e7ff'
            },
            {
                lightness: 17
            }
        ]
    }
];

import activitiesMapSlider from '@/components/activities-map-slider';
import { gmapApi } from 'vue2-google-maps';

export default {
    components: {
        activitiesMapSlider
    },
    props: {
        activities: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            mapStyle: mapStyle,
            center: { lat: 52.370216, lng: 4.895168 },
            currentMidx: null,
            infoWindowPos: null,
            infoWinOpen: false,
            infoCurrentKey: null,
            currentActivities: [],
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            render: false
        };
    },
    computed: {
        google: gmapApi
    },
    watch: {
        activities: function() {
            this.waitForMap();
        }
    },
    created() {
        this.waitForMap();
    },
    methods: {
        waitForMap: function() {
            const _this = this;

            this.$nextTick(() => {
                _this.adjustZoom();
            });
        },
        adjustZoom: function() {
            if (this.$refs.marker == null || this.$refs.marker.length === 0) {
                return;
            }

            if (this.google != null) {
                const bounds = new this.google.maps.LatLngBounds();

                for (let i = 0; i < this.$refs.marker.length; i++) {
                    if (
                        this.$refs.marker[i].position &&
                        this.$refs.marker[i].position.lat &&
                        this.$refs.marker[i].position.lng
                    ) {
                        bounds.extend(
                            new this.google.maps.LatLng(
                                parseFloat(this.$refs.marker[i].position.lat),
                                parseFloat(this.$refs.marker[i].position.lng)
                            )
                        );
                    }
                }

                this.$refs.map.fitBounds(bounds);
            }
        },
        toggleInfoWindow: function(marker, index) {
            if (marker.lat && marker.long) {
                this.center = {
                    lat: parseFloat(marker.lat) + 0.075,
                    lng: parseFloat(marker.long)
                };

                this.currentActivities = [];
                this.render = false;
                this.activities.forEach(function(activity) {
                    if (
                        activity.lat === marker.lat &&
                        activity.long === marker.long
                    ) {
                        this.currentActivities.push(activity);
                    }
                }, this);

                this.infoWindowPos = {
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.long)
                };
            }

            if (this.currentMidx == index) {
                this.infoWinOpen = !this.infoWinOpen;
            } else {
                this.infoWinOpen = true;
                this.currentMidx = index;
            }
            if (this.infoWinOpen) {
                const _this = this;
                setTimeout(function() {
                    _this.render = true;
                }, 200);
                setTimeout(function() {
                    _this.$refs.activitiesMapSlider.initSlider();
                }, 500);
            }
        },
        initSlider() {
            this.$refs.activitiesMapSlider.initSlider();
        }
    }
};
</script>

<style lang="scss">
.vue-map-container,
.vue-map-container .vue-map {
    width: 100%;
    height: 100%;
}

.gm-style-iw button {
    background-color: $white !important;
    margin-right: 56px !important;
    margin-top: 26px !important;
}

.gm-style .gm-style-iw-c {
    padding: 0 !important;
    box-shadow: none !important;
    background: none !important;
    overflow: hidden !important;
    border-radius: 0 !important;
}

.gm-style .gm-style-iw-d {
    overflow: hidden !important;
}

.activity-map__results .tns-inner {
    padding: 20px 0 0 0;

    @include media-breakpoint-up(md) {
        padding: 20px 0 0 0;
    }
}
</style>

<style lang="scss" scoped>
.gm-style-iw button {
    display: none !important;
}

.card {
    padding: 0;
    font-size: 1rem;
}

.activity-map__results {
    position: relative;
    width: 86vw;
    height: 100%;
    left: 7vw;
    top: 0;
    margin: 0;

    @include media-breakpoint-up(lg) {
        position: absolute;
        width: 75%;
        left: 25%;
    }
}
</style>
